import UIkit from '../util/uikit.min';
import  Icons from '../util/uikit-icons.min';

UIkit.use(Icons);
window.UIkit = UIkit;
